import { HttpClient } from "@angular/common/http";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { SubscriptionService } from "src/app/core/service/subscription.service";
import { TranslationLoaderService } from "src/app/core/service/translation-loader.service";
import { locale as english } from "./i18n/en-US";
import { locale as spanish } from "./i18n/es-ES";
import { locale as portuguese } from "./i18n/pt-BR";

@Component({
    selector: "app-privacy-police-dialog",
    templateUrl: "./privacy-police-dialog.component.html",
    styleUrls: ["./privacy-police-dialog.component.scss"]
})
export class PrivacyPoliceDialogComponent implements OnInit, OnDestroy {
    private _unsubscribeAll: Subject<any>;

    privacyPolicy: string;

    constructor(
        private _translationLoaderService: TranslationLoaderService,
        private _translateService: TranslateService,
        private _httpClient: HttpClient,
        private _apiSubscriptionsService: SubscriptionService
    ) {
        // Load the translations
        this._translationLoaderService.loadTranslations(english, portuguese, spanish);

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this.privacyPolicy = null;
    }

    ngOnInit(): void {
        const url = this._apiSubscriptionsService.currentSubscription?.settings?.privacyPolicyUrl;

        if (!url) {
            this._translateService
                .get("PRIVACY_POLICE.DEFAULT")
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe((res) => (this.privacyPolicy = res));
        }

        this._httpClient
            .get(url, { responseType: "text" })
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(
                (response) => (this.privacyPolicy = response),
                (err) => {
                    console.log(err);
                    this._translateService
                        .get("PRIVACY_POLICE.SUBMIT_ERROR")
                        .pipe(takeUntil(this._unsubscribeAll))
                        .subscribe((res) => (this.privacyPolicy = res));
                }
            );
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
